import type { TOptionShape } from '@alfa-bank/site-select-v2/src/models/common';

import type { TValidationRules, TValidationTypes } from '../models/validation';
import { IS_REQUIRED, MAX_COUNT, MIN_COUNT } from '../models/config';
import { formatValidationMessage } from '../helpers';

const EMPTY_MESSAGE = 'Поле заполнено не верно';
const VALID_STATUS = undefined;

type TGetCondition = (
    value: TOptionShape[],
    rules: TValidationRules,
    isMultiple?: boolean
) => boolean;

const getRequiredCondition: TGetCondition = (value, rules) =>
    Boolean(!value.length && rules.isRequired);

type TGetCountCondition<T> = (type: T) => TGetCondition;

const getCountCondition: TGetCountCondition<typeof MIN_COUNT | typeof MAX_COUNT> =
    (type): TGetCondition =>
    (value, rules, isMultiple) => {
        let tempCondition: boolean | undefined;
        switch (type) {
            case MAX_COUNT:
                tempCondition = rules.maxCount && value.length > rules.maxCount.value;
                break;
            case MIN_COUNT:
                tempCondition = rules.minCount && value.length < rules.minCount.value;
                break;
        }

        return Boolean(isMultiple && value.length && tempCondition);
    };

export const validateCondions: Record<TValidationTypes, TGetCondition> = {
    [IS_REQUIRED]: getRequiredCondition,
    [MIN_COUNT]: getCountCondition(MIN_COUNT),
    [MAX_COUNT]: getCountCondition(MAX_COUNT),
};

export const getValidateStatus =
    (
        rules?: TValidationRules,
        isMultiple?: boolean,
        defaultStatus: string | undefined = VALID_STATUS,
        defaultMessage: string = EMPTY_MESSAGE
    ) =>
    (value: TOptionShape[]) => {
        let tempArray: TValidationTypes[] = [];
        if (rules) tempArray = Object.keys(rules) as TValidationTypes[];

        return rules
            ? tempArray.reduce<string | typeof VALID_STATUS>((acc, item) => {
                  const condition = validateCondions[item](value, rules, isMultiple);
                  if (condition)
                      return formatValidationMessage({ ...rules[item] }) || defaultMessage;

                  return acc;
              }, defaultStatus)
            : defaultStatus;
    };
